module.exports = __webpack_public_path__ + "static/img/dashuju1.0bd7a09.png";


//////////////////
// WEBPACK FOOTER
// ./public/hadoopImg/dashuju1.png
// module id = NC4n
// module chunks = 0